import React from 'react';
interface HerbItem {
  name: string;
  description: string;
}
interface HerbGridProps {
  items: HerbItem[];
}
export function HerbGrid({
  items
}: HerbGridProps) {
  return <div className="grid grid-cols-2 gap-4 my-7 mb-9 max-[560px]:grid-cols-1" data-id="element-12">
      {items.map((item, index) => <div key={index} className="bg-cream border border-border p-5 px-[18px] rounded-[3px]" data-id="element-13">
          <span className="font-lora text-[16px] font-bold text-teal mb-2 block" data-id="element-14">
            {item.name}
          </span>
          <p className="font-lora text-[14px] leading-[1.6] text-[#222222] m-0" data-id="element-15">
            {item.description}
          </p>
        </div>)}
    </div>;
}